import {enableEditMode, disableEditMode} from "./edit-mode";

export function initUI() {
    const toggle = document.getElementById("switchEditMode");
    if (!toggle) return;

    toggle.addEventListener("change", e => {
        e.target.checked ? enableEditMode() : disableEditMode();
    });
}

export function toggleGallery(show) {
    const el = document.getElementById("image-gallery");
    if (el) el.classList.toggle("hidden", !show);
}
